// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ski-policy-exception-management.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ski-policy-exception-management',
  title: 'Maintain process for IS policy exceptions and deviations',
  description:
    'Establish and maintain a documented process for handling exceptions and deviations from the information security policy and its supporting policies. Each exception must be formally recorded, risk-assessed, time-limited and approved by an authorised owner. Channels must exist to report policy breaches and suspected weaknesses.',
  category: 'governance',
  scfIds: ['SCF-GOV-001'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Policy exception and deviation procedure is published',
    },
    { type: 'document-approved', description: 'Procedure has been approved' },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
